import { getFlightItemPolicyEvaluationCostFromView } from 'checkout/lib/utils/flights/getFlightItemViewPrice'
import type { CartEvaluationItemInputWire } from 'businessTraveller/api/requestPostCartEvaluation'

type BuildFlightDateChangeCartEvaluationItemsParams = {
  flightItemsViews: App.WithDataStatus<Array<App.Checkout.FlightItemView>>
  currencyCode: string
  /** The booking employee, may not be the traveller on the order */
  employeeId: string | undefined
  travellerCount: number
}

export function buildFlightDateChangeCartEvaluationItems(
  params: BuildFlightDateChangeCartEvaluationItemsParams,
): Array<CartEvaluationItemInputWire> {
  const { flightItemsViews, currencyCode, employeeId, travellerCount } = params

  if (!flightItemsViews.hasRequiredData || !employeeId) {
    return []
  }

  const travellers: CartEvaluationItemInputWire['travellers'] = [
    { employeeId, isPrimaryTraveller: true },
    ...Array.from({ length: Math.max(travellerCount - 1, 0) }, () => ({ isPrimaryTraveller: false })),
  ]

  return flightItemsViews.data.map((flightItemView) => ({
    transactionKey: `${flightItemView.item.transactionKey}--date-change`,
    cartItemId: flightItemView.item.itemId,
    // A zero cost change still evaluates, so an ALWAYS approval policy applies
    cost: getFlightItemPolicyEvaluationCostFromView(flightItemView),
    travellers,
    itemPolicyLookup: {
      itemPolicyType: 'FLIGHT_DATE_CHANGE',
      currencyCode,
      // oneWay = one leg changed, return = both legs changed; carried on the cart item
      // because checkout initialise resets the flights date change state.
      flightViewType: flightItemView.item.dateChangeChangedLegCount === 2 ? 'return' : 'oneWay',
      travellerCount,
    },
  }))
}
